var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-24",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50.742","height":"196.488","viewBox":"0 0 50.742 196.488"}},[_c('path',{attrs:{"d":"M-3262.478,3481.817l49.232,97.907-49.232,97.907","transform":"translate(3263.148 -3481.48)","fill":"none","stroke":"#e56b7f","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }